import { generateSrcSet } from '@core/Components/HeycarImage/GenerateSrcSet';
import { Typography } from '@gds/Typography/Typography';
import { umbracoImageLoader } from '@umbraco/Utils/UmbracoImageLoader';

import { TrackedLink } from '../../TrackedLink/TrackedLink';

import styles from './ImageSubNavItem.module.css';

interface ImageSubNavItemProps {
  label: string;
  image: string[];
  imageAltTexts?: string[];
  link?: string;
  description?: string;
  date?: string;
  origin?: 'header' | 'footer';
  isNavMenuList?: boolean;
  navItemId?: string;
}

export const ImageSubNavItem: React.FC<ImageSubNavItemProps> = ({
  label,
  image,
  imageAltTexts,
  link,
  description,
  date,

  origin,
  isNavMenuList,
  navItemId,
}) => (
  <TrackedLink
    className={styles.subNavImgLink}
    href={link}
    trackingObj={{ label: label, href: link }}
    origin={origin}
    isNavMenuList={isNavMenuList}
    navItemId={navItemId}
  >
    {image?.[0] && (
      <div className={styles.subNavImg}>
        <img
          src={image[0]}
          srcSet={generateSrcSet(image[0], umbracoImageLoader, [100, 200])}
          alt={imageAltTexts?.[0] || label}
          sizes="100px"
        />
      </div>
    )}
    <div className={styles.subNavImgContent}>
      <Typography variant="body2" className={styles.imageLinkLabel}>
        {label}
      </Typography>

      {date && (
        <Typography className={styles.subNavImgDate} variant="caption1" Component="div">
          {new Date(date).toLocaleDateString()}
        </Typography>
      )}
      {description && (
        <Typography variant="caption2" Component="div" className={styles.subNavImgDescription}>
          {description}
        </Typography>
      )}
    </div>
  </TrackedLink>
);
